import React, { useState } from "react";

const Step5 = ({ formData, updateField, goPrev, onSubmit }) => {
  const [errorAgree, setErrorAgree] = useState("");

  const handleSubmit = e => {
    e.preventDefault();
    if (!formData.agree) {
      setErrorAgree("You must agree to the Privacy Policy to continue.");
      return;
    }
    setErrorAgree("");
    onSubmit(e);
  };

  return (
    <div className="form-order-services__step form-order-services__step--5">
      <h2 className="form-order-services__step-title txt-h4">
        Let us know how we can contact you to finish your order.
      </h2>

      <div className="form-order-services__column-container">
        <div className="form-order-services__column form-order-services__column--full">
          <label className="sc-form-item" for="role">
            <span className="sc-form-item__label">Role</span>
            <input
              className="sc-form-item__field"
              type="text"
              id="role"
              name="role"
              value={formData.role || ""}
              onChange={e => updateField("role", e.target.value)}
            />
          </label>
        </div>
        <div className="form-order-services__column"></div> {/* spacer */}
      </div>

      <div className="form-order-services__column-container">
        <div className="form-order-services__column">
          <label className="sc-form-item" for="firstName">
            <span className="sc-form-item__label">First Name</span>
            <input
              className="sc-form-item__field"
              type="text"
              id="firstName"
              name="firstName"
              value={formData.firstName || ""}
              onChange={e => updateField("firstName", e.target.value)}
            />
          </label>
        </div>
        <div className="form-order-services__column">
          <label className="sc-form-item" for="lastName">
            <span className="sc-form-item__label">Last Name</span>
            <input
              className="sc-form-item__field"
              type="text"
              id="lastName"
              name="lastName"
              value={formData.lastName || ""}
              onChange={e => updateField("lastName", e.target.value)}
            />
          </label>
        </div>
      </div>

      <div className="form-order-services__column-container">
        <div className="form-order-services__column">
          <label className="sc-form-item" for="email">
            <span className="sc-form-item__label">Email</span>
            <input
              className="sc-form-item__field"
              type="email"
              id="email"
              name="email"
              value={formData.email || ""}
              onChange={e => updateField("email", e.target.value)}
            />
          </label>
        </div>
        <div className="form-order-services__column">
          <label for="phone" className="sc-form-item">
            <span className="sc-form-item__label">Phone Number</span>
            <input
              className="sc-form-item__field"
              type="tel"
              name="phone"
              id="phone"
              placeholder="999-999-9999"
              value={formData.phone || ""}
              onChange={e => updateField("phone", e.target.value)}
            />
          </label>
        </div>
      </div>

      <div className="form-order-services__column-container">
        <div className="form-order-services__column form-order-services__column--full">
          <label className="sc-form-item" for="comments">
            <span className="sc-form-item__label">Comments (Optional)</span>
            <textarea
              className="sc-form-item__field sc-form-item__field--textarea"
              name="comments"
              id="comments"
              rows="4"
              value={formData.comments || ""}
              onChange={e => updateField("comments", e.target.value)}
            />
          </label>
        </div>
      </div>

      <div className="form-order-services__column-container">
        <div className="form-order-services__column form-order-services__column--full">
          <label
            for="sendCopy"
            className="form-order-services__checkbox-option"
          >
            <input
              type="checkbox"
              name="sendCopy"
              id="sendCopy"
              checked={formData.sendCopy || false}
              onChange={e => updateField("sendCopy", e.target.checked)}
            />
            <span>Send a copy of this Order Service to the email above</span>
          </label>
        </div>
      </div>

      <div className="form-order-services__column-container">
        <div className="form-order-services__column form-order-services__column--full">
          <label for="agree" className="form-order-services__checkbox-option">
            <input
              type="checkbox"
              name="agree"
              id="agree"
              checked={formData.agree || false}
              onChange={e => updateField("agree", e.target.checked)}
              aria-required="true"
              aria-invalid={errorAgree ? "true" : "false"}
            />
            <span>I agree to the Privacy Policy</span>
          </label>
          {errorAgree && (
            <div className="form-order-services__error" role="alert">
              {errorAgree}
            </div>
          )}
        </div>
      </div>

      <div className="form-order-services__actions">
        <button type="button" className="btn btn--secondary" onClick={goPrev}>
          BACK
        </button>
        <button
          type="submit"
          className="btn btn--primary"
          onClick={handleSubmit}
          disabled={!formData.agree}
        >
          Submit
        </button>
      </div>
    </div>
  );
};

export default Step5;
